import api from './api';
import { getJwt } from '@app/helpers';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

export interface SeguroGarantiaFilter {
  status: string[];
}

export interface RelatorioSegurosGarantias {
  numeroContrato: string;
  fornecedor: string;
  tipoDocumento: string;
  vigenciaInicio: string;
  vigenciaFim: string;
  status: string;
}

export const searchValues = (values: SeguroGarantiaFilter) => {
  return api.post<RelatorioSegurosGarantias[]>('relatorios/segurogarantia', values, {
    disableNotification: 'true',
  });
};


export const relatorioExportExcel = (values: SeguroGarantiaFilter) => {

  let urlBase = window.location.origin;
  trackPromise(Axios.post(urlBase + `/api/relatorios/segurogarantia/excel`, values,
    {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "relatorio_seguro_e_garantia.xlsx");
      link.setAttribute('id', 'downloadElementrelatorio_segurosGarantias');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElementrelatorio_segurosGarantias').outerHTML = '';
    }));
};
